<template>
    <div>
        <button class="btn btn-light settingsBtn allBoxShadows" id="settingsBtn">
            <i class="fad fa-cogs faIcons"></i>
        </button>
        <div id="c-menu--slide-left" class="c-menu c-menu--slide-left">
            <div class="w-100">
                <div class="heading bg-light pb-3">
                    <button class="c-menu__close allBoxShadow">
                        <i class="fa fa-times faTimesIcons d-block"></i>
                    </button>
                    <span class="mt-2"> تنظیمات </span>
                </div>
                <div id="settingsBody">
                    <form>
                        <div class="radio-tile-group">
                            <div class="input-container">
                                <input id="iran" value="iran" class="radio-button" type="radio" name="country" checked>
                                <div class="radio-tile">
                                    <label for="iran" class="radio-tile-label"> ایران </label>
                                </div>
                            </div>
                            <div class="input-container">
                                <input id="usa" value="usa" class="radio-button" type="radio" name="country">
                                <div class="radio-tile">
                                    <label for="usa" class="radio-tile-label"> آمریکا </label>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <div id="c-mask2"></div>
    </div>
</template>

<script>
    import {fromLonLat, transformExtent} from 'ol/proj';
    import Menu from '@/assets/js/menu';

    let countries = {
        iran: {
            title: 'ایران',
            center: fromLonLat([53.34960937499999, 32.472695022061515]),
            extent: transformExtent([44.0383, 25.0784, 63.3178, 39.7821], 'EPSG:4326', 'EPSG:3857')
        },
        usa: {
            title: 'آمریکا',
            center: fromLonLat([-97.88513700126691, 40.23197970177981]),
            extent: transformExtent([-125.0017, 24.9493, -66.9326, 49.5904], 'EPSG:4326', 'EPSG:3857')
        }
    };

    export default {
        name: "Settings",
        data() {
            return {
                map: this.$store.getters["map/getMap"]
            }
        },
        mounted() {
            this.initializeMenu();
            this.setupCountrySelection();
        },
        methods: {
            initializeMenu() {
                const slideLeft = new Menu({
                    wrapper: '#o-wrapper',
                    type: 'slide-left',
                    menuOpenerClass: '.settingsBtn',
                    maskId: '#c-mask2'
                });
                const slideLeftBtn = document.getElementById("settingsBtn");
                slideLeftBtn.addEventListener('click', (e) => {
                    e.preventDefault();
                    slideLeft.open();
                });
            },

            setupCountrySelection() {
                const map = this.map;
                $('input[type=radio][name=country]').change(function () {
                    const selectedCountry = countries[this.value];
                    if (selectedCountry) {
                        map.getView().fit(selectedCountry.extent, {duration: 2000});
                    }
                });
            }
        }
    }
</script>

<style>
    #settingsBody {
        padding: 10px !important;
        z-index: 4554545454 !important;
        font-size: 13px;
    }
</style>

<style lang="scss" scoped>
    @import "@/assets/css/tokens";

    .faIcons {
        transform: translateY(2.5px);
        color: $text-secondary;
    }

    .faTimesIcons {
        transform: translate(3px, 3.3px);
        font-size: 24px;
        width: auto;
        height: 1.5em;
    }

    #settingsBtn {
        position: absolute;
        width: 50px;
        height: 50px;
        left: 70px !important;
        bottom: 10px !important;
        z-index: 2;
        padding: 6px 3px;
        font-size: 25px;
    }

    #c-menu--slide-left {
        height: auto;
        max-height: 400px;
        background-color: $bg-card;
    }

    .c-menu--slide-left .c-menu__close {
        border-radius: 6px;
        margin-left: 10px;
        display: inline-block;
        padding: 0 10px;
        width: 30px;
        height: 30px;
        line-height: 90px;
        z-index: 3453453453;
    }

    .radio-tile-group {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
    }
    .radio-tile-group .input-container {
        position: relative;
        height: 2rem;
        width: 5rem;
        margin: 0.5rem;
    }
    .radio-tile-group .input-container .radio-button {
        opacity: 0;
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        margin: 0;
        cursor: pointer;
    }
    .radio-tile-group .input-container .radio-tile {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        border-radius: 8px;
        padding: 1rem;
        transition: transform 300ms ease, background 0.25s ease, color 0.25s ease;
    }
    .radio-tile-group .input-container .radio-tile-label {
        text-align: center;
        font-size: 12px;
        font-weight: 600;
        color: $accent-blue;
        margin-top: 6px;
    }
    .radio-tile-group .input-container .radio-button:checked + .radio-tile {
        background: $gradient-main;
        color: #fff;
        transform: scale(1.08);
        box-shadow: 0 4px 14px rgba($accent-blue, 0.25);
    }
    .radio-tile-group .input-container .radio-button:checked + .radio-tile .radio-tile-label {
        color: #fff;
    }
</style>
